module.exports = __webpack_public_path__ + "d3a912f857b04f2b68a43c4cf786c25a.jpg";